import { render, staticRenderFns } from "./RemoveMemberDialog.vue?vue&type=template&id=99697f7c"
import script from "./RemoveMemberDialog.vue?vue&type=script&lang=js"
export * from "./RemoveMemberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports